import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Button } from "semantic-ui-react";

/**
 * A button wrapper that shows a loading icon.
 */
export default class LoadingButton extends Component {
  onClick(e) {
    e.preventDefault();

    const { loading, onClick } = this.props;

    if (loading) {
      return null;
    }

    return onClick(e);
  }

  render() {
    const { as: Element, loading, onClick, className, ...props } = this.props;
    const buttonClass = classNames(className, { loading });

    return (
      <Element className={buttonClass} onClick={e => this.onClick(e)} {...props} style={{ whiteSpace: "nowrap" }} />
    );
  }
}

LoadingButton.defaultProps = {
  as: Button,
};

LoadingButton.propTypes = {
  as: PropTypes.func,
  loading: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
